<template>
  <div>
    <h1 class="page-header">{{ $t('dailyAttendance.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-2 form-group">
              <label class="required">{{ $t('dailyAttendance.date')}}</label>
              <ts-date-picker-input v-model="model.date"></ts-date-picker-input>
              <div class="text-danger mt-2" v-if="errors.has('date')">{{ errors.first('date')}}</div>
            </div>
            <div class="col-md-2 form-group">
              <label class="required">{{ $t('dailyAttendance.organisationalStructure')}}</label>
              <treeselect
                :load-options="loadOptions"
                :options="options"
                :placeholder="$t('select')"
                v-model="model.org_chart_structure_id"
              />
              <div
                class="text-danger mt-2"
                v-if="errors.has('org_chart_structure_id')"
              >{{ errors.first('org_chart_structure_id')}}</div>
            </div>
            <div class="col-md-2 form-group">
              <label>{{ $t('dailyAttendance.status')}}</label>
              <select class="form-control" v-model="model.status">
                <option value>All</option>
                <option value="Present">Present</option>
                <option value="Absent">Absent</option>
                <option value="Take Leave">Take Leave</option>
              </select>
            </div>
            <div class="col-md-2 form-group">
              <label></label>
              <ts-button
                @click="fetchData"
                class="mt-4"
                color="primary"
                :waiting="loading"
              >{{$t('search')}}</ts-button>
            </div>
          </div>
        </form>
        <div class="overflow-auto">
          <div id="table-container">
            <ts-table :records="resources">
              <template v-slot:thead>
                <thead>
                  <tr>
                    <th rowspan="2" style="width:8%">{{ $t('dailyAttendance.employeeCard') }}</th>
                    <th rowspan="2" style="width:12%">{{ $t('dailyAttendance.employeeName') }}</th>
                    <th rowspan="2">{{ $t('dailyAttendance.shift') }}</th>
                    <th rowspan="2">{{ $t('dailyAttendance.position') }}</th>
                    <th colspan="2" class="text-center">{{ $t('dailyAttendance.t1') }}</th>
                    <th colspan="2" class="text-center">{{ $t('dailyAttendance.t2') }}</th>
                    <th colspan="2" class="text-center">{{ $t('dailyAttendance.t3') }}</th>
                    <th colspan="2" class="text-center">{{ $t('dailyAttendance.t4') }}</th>
                    <th rowspan="2">{{ $t('dailyAttendance.total1') }}</th>
                    <th rowspan="2">{{ $t('dailyAttendance.total2') }}</th>
                    <th rowspan="2">{{ $t('dailyAttendance.total3') }}</th>
                    <th rowspan="2">{{ $t('dailyAttendance.total4') }}</th>
                  </tr>
                  <tr>
                    <td class="border-right">{{ $t('dailyAttendance.checkin') }}</td>
                    <td class="border-right">{{ $t('dailyAttendance.checkout') }}</td>
                    <td class="border-right">{{ $t('dailyAttendance.checkin') }}</td>
                    <td class="border-right">{{ $t('dailyAttendance.checkout') }}</td>
                    <td class="border-right">{{ $t('dailyAttendance.checkin') }}</td>
                    <td class="border-right">{{ $t('dailyAttendance.checkout') }}</td>
                    <td class="border-right">{{ $t('dailyAttendance.checkin') }}</td>
                    <td>{{ $t('dailyAttendance.checkout') }}</td>
                  </tr>
                  <TableProgressBar v-show="loading" :columnLength="16" />
                </thead>
              </template>
              <template v-slot="{ record, index }">
                <td>{{ record.card_id }}</td>
                <td>{{ record.employee_name_en }}</td>
                <td>{{ record.shift_name }}</td>
                <td>{{ record.position }}</td>
                <td>{{ record.t1 }}</td>
                <td>{{ record.t2 }}</td>
                <td>{{ record.t3 }}</td>
                <td>{{ record.t4 }}</td>
                <td>{{ record.t5 }}</td>
                <td>{{ record.t6 }}</td>
                <td>{{ record.t7 }}</td>
                <td>{{ record.t8 }}</td>
                <td>{{ record.total_hour1 }}</td>
                <td>{{ record.total_hour2 }}</td>
                <td>{{ record.total_hour3 }}</td>
                <td>{{ record.total_hour4 }}</td>
              </template>
            </ts-table>
          </div>
          <div class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'dailyAttendance',
  components: { TableProgressBar },
  data() {
    return {
      loading: false,
      model: {
        date: moment().format('DD-MM-YYYY'),
        org_chart_structure_id: null,
        status: ''
      },
      options: null,
      errors: new Errors()
    }
  },
  created() {},
  computed: {
    ...mapState('hr/dailyAttendance', ['resources', 'pagination'])
  },
  methods: {
    ...mapActions('hr/dailyAttendance', ['fetchOrgStructures']),
    async loadOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.options = null
        let response = await this.fetchOrgStructures()
        this.options = response.data.map(el => ({
          id: el.org_chart_structure_id,
          label: el.org_chart_structure
        }))
      }
    },
    fetchData(attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('hr/dailyAttendance/fetch', Object.assign({}, this.model, attributes))
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#table-container {
  min-height: 60vh;
  overflow-y: scroll;
}

table td,
th {
  vertical-align: middle;
}
table th {
  border: 1px solid gray;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
/* customize fieldset style */
fieldset {
  border: 1px solid #c3c3c3;
  padding: 10px 15px !important;
  border-radius: 4px;
}

fieldset legend {
  border: 1px solid #ffff;
  width: auto;
  padding: 5px 14px;
  // border-radius: 7px;
  font-size: 14px;
  // box-shadow: -1px 4px 27px -7px #bdbdbd;
  background: #fffdfd;
}
.border-right {
  border-right: 1px solid #e2e2e2;
}
</style>